const isEmailValid = (email: string): boolean =>{
        const emailRegex = /^([\w+-]+(?:\.[\w+-]+)*)@((?:[\w-]+\.)*\w[\w-]{0,66})\.([a-z]{2,15}(?:\.[a-z]{2})?)$/i;
        return !!email && emailRegex.test(email);
    }

export default isEmailValid